import { FC, ReactNode } from 'react';

import { CheckboxProps, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';

import './CheckboxFormItem.scss';
import CustomCheckbox from './CustomCheckbox';

interface ICheckboxFormItemProps extends CheckboxProps {
	name: NamePath;
	className?: string;
	children: ReactNode;
	rules?: Rule[];
	required?: boolean;
}

const CheckboxFormItem: FC<ICheckboxFormItemProps> = ({
	name,
	rules,
	children,
	className = '',
	required = true,
	...rest
}) => {
	return (
		<Form.Item
			className={`checkbox ${className}`}
			name={name}
			rules={
				rules ?? [
					{
						validator: (_, value) => {
							if (required && !value) {
								return Promise.reject();
							}

							return Promise.resolve();
						},
					},
				]
			}
			valuePropName="checked"
		>
			<CustomCheckbox {...rest}>{children}</CustomCheckbox>
		</Form.Item>
	);
};

export default CheckboxFormItem;
